export enum IataCodeEnum {
    MIAMI_IATA_CODE = "MIA",
    ORLANDO_IATA_CODE = "MCO",
    CANCUN_IATA_CODE = "CUN"
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/iata-code.enum.ts